import buildFullPath from 'axios/lib/core/buildFullPath';
import querystring from 'qs';

export const protocolre = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\S\s]*)/i;

export const whitespace =
  '[\\x09\\x0A\\x0B\\x0C\\x0D\\x20\\xA0\\u1680\\u180E\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200A\\u202F\\u205F\\u3000\\u2028\\u2029\\uFEFF]';

export const left = new RegExp(`^${whitespace}+`);

export function trimLeft(str) {
  return (str || '').toString().replace(left, '');
}

export function extractProtocol(address) {
  const newAddress = trimLeft(address);
  const match = protocolre.exec(newAddress);
  return {
    protocol: match[1] ? match[1].toLowerCase() : '',
    slashes: !!match[2],
    rest: match[3],
  };
}

export function preparCombineParams(currentConfig, previousRewriteConfig) {
  const conf = {
    ...previousRewriteConfig,
    data: previousRewriteConfig.data || [],
  };
  if (currentConfig.url) {
    // 如果包含params 需要前置处理，传递给后端接口
    const fullPath = buildFullPath(currentConfig.baseURL, currentConfig.url);
    // 不需要构建完整的url, 后端接口不支持
    // const finalUrl = buildURL(
    //   fullPath,
    //   currentConfig.params,
    //   currentConfig.paramsSerializer
    // );
    const extUrl = extractProtocol(fullPath);
    const basePath = extUrl.rest.substr(extUrl.rest.indexOf('/'));
    // .replace(/(#).*$/i, '');
    conf.data.push({
      url: basePath,
      params: {
        ...currentConfig.data,
        ...currentConfig.params,
      },
    });
  }

  return conf;
}

/**
 * 合并后的参数进行最后的处理
 *
 * @export
 * @param {*} config
 * @returns
 */
export function combineParamSerializer(config) {
  return {
    ...config,
    data: querystring.stringify({
      requests: JSON.stringify(config && config.data),
    }),
  };
}
